import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { ScheduleCalendar } from "@/components"
import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { ScheduleDetailsOfDate } from "@/components/schedule/details-of-date"
import { ScheduleInstallmentsTable } from "@/components/schedule/table"
import { FRONTEND_ROUTES } from "@/constants"

export function SchedulePage() {
  const { t } = useTranslation()

  const appBreadcrumbLinks = [
    {
      href: FRONTEND_ROUTES.DASHBOARD.href,
      label: t("sidebar.dashboard"),
    },
    {
      label: t("sidebar.schedule"),
    },
  ]

  return (
    <Suspense fallback={<div>{t("common.loading")}</div>}>
      <DashboardContainer>
        <Header>
          <AppBreadcrumb links={appBreadcrumbLinks} />
        </Header>
        <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
          <div>
            <h1 className="page-title">
              {t("pages.schedule.title")}
            </h1>
            <h2 className="page-subtitle text-muted-foreground">
              {t("pages.schedule.subtitle")}
            </h2>
          </div>
          <div className="grid items-start gap-6 xl:grid-cols-2">
            <ScheduleCalendar />
            <ScheduleDetailsOfDate />
          </div>
          <ScheduleInstallmentsTable />
        </section>
      </DashboardContainer>
    </Suspense>
  )
}
